import { useQuery } from "@tanstack/react-query";
import {
  type GetLoyaltyOverviewQueryResult,
  getLoyaltiesOverview,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const LOYALTIES_OVERVIEW_QUERY_KEY = "LOYALTIES_OVERVIEW";

export const loyaltiesOverviewKeys = {
  all: [LOYALTIES_OVERVIEW_QUERY_KEY],
};

type Props = {
  enabled?: boolean;
};

export const useLoyaltiesOverviewQuery = ({ enabled = true }: Props = {}) =>
  useQuery<GetLoyaltyOverviewQueryResult>({
    queryKey: loyaltiesOverviewKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getLoyaltiesOverview()),
    enabled,
  });
